"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import CopyRoleDialog from "./dialog/CopyRoleDialog.vue";
import ConfigRoleMumbersDialog from "./dialog/ConfigRoleMumbersDialog.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let RoleManage = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/roles/bypage")
    );
    this.selectDatas = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  gridSort(data) {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  addRoles() {
    return __async(this, null, function* () {
      this.$router.push("/add_roles");
    });
  }
  editRole(data) {
    return __async(this, null, function* () {
      this.$router.push({ name: "AddRoles", query: { "id": data.guid } });
    });
  }
  editMembers(data) {
    return __async(this, null, function* () {
      this._configRoleMumbersDialog.open(data);
    });
  }
  copyRole(data) {
    return __async(this, null, function* () {
      this._copyRoleDialog.open(data);
    });
  }
  deleteRole(data) {
    return __async(this, null, function* () {
      try {
        if (data.userCount > 0) {
          yield UiConfirm.warnconfirm(this.$t("role_management.table.delete_role_has_user_content"), this.$t("role_management.table.delete_role_has_user_title"), {
            confirmButtonText: this.$t("role_management.table.delete_role_has_user_confirm_button"),
            showCancelButton: false
          });
          return;
        }
        yield UiConfirm.warnconfirm(this.$t("role_management.table.delete_role_confirm_content", { roleName: data.name }), this.$t("role_management.table.delete_role_confirm"), {
          confirmButtonText: this.$t("role_management.table.delete_role_confirm_button"),
          cancelButtonText: this.$t("role_management.table.delete_role_cancel_button")
        });
        yield API.delete(`api://base.auth/api/v1/roles`, {
          data: {
            ids: [data.guid]
          }
        });
        this.$message.success(this.$t("role_management.table.delete_role_success"));
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleCommand(data) {
    return __async(this, null, function* () {
      switch (data.path) {
        case "edit-members":
          this.editMembers(data.method);
          break;
        case "copy-role":
          this.copyRole(data.method);
          break;
        case "delete-role":
          this.deleteRole(data.method);
          break;
        default:
          break;
      }
    });
  }
  selectItems(items) {
    this.selectDatas = items;
  }
};
__decorateClass([
  Ref("copyRoleDialog")
], RoleManage.prototype, "_copyRoleDialog", 2);
__decorateClass([
  Ref("configRoleMumbersDialog")
], RoleManage.prototype, "_configRoleMumbersDialog", 2);
RoleManage = __decorateClass([
  Component({
    components: {
      UiGrid,
      CopyRoleDialog,
      ConfigRoleMumbersDialog
    }
  })
], RoleManage);
export {
  RoleManage as default
};
